import { HierarchyNode } from '®shared/hierarchy';

export type NodeAndOverride = {
  node: HierarchyNode;
  overriddenStudentNumbers: number | null;
};

export function getStudentNumbersOrOverridden(
  nodeAndOverride: NodeAndOverride | null,
): number {
  if (!nodeAndOverride) {
    return 0;
  }

  const { node, overriddenStudentNumbers } = nodeAndOverride;
  if (Number.isInteger(overriddenStudentNumbers)) {
    return overriddenStudentNumbers;
  } else if (node && Number.isInteger(node.student_numbers)) {
    return node.student_numbers;
  }
  return 0;
}
